import React, { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TripOriginIcon from '@mui/icons-material/TripOrigin';


const UserGuidePage = () => {

  // State Variables
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div>
      <div className="row my-2">
        <div className="float-l">
          <h5 className="header-color"><img src='/assets/icons/book.svg' alt=""  className="header-icon"  /> User Guide</h5>
        </div>
      </div>
      <hr/>
      <div className="card shadow mb-1 my-2">
        <Accordion className="mx-1 my-2 custom-accordion-button">
          <Accordion.Button
            as={Nav.Link}
            variant="link"
            eventKey="0"
            onClick={()=> setCollapsed(!collapsed)}
          >
            <div className='header-cont' >
              <div>
                <span className="m-2 card-heading-2">About ECS</span>
              </div>
              <div>{collapsed ? <KeyboardArrowUpIcon /> : <ExpandMoreIcon /> }</div>
            </div>
          </Accordion.Button>
          
          <Accordion.Body eventKey="0">
            <div className="card-body p-4">
              <div id="platfromtabcontent">
                <h6 id="h61" className='card-text-1'><b>Introduction:</b></h6>
                <p className="card-text">
                  <b>External Cyber Score </b> 
                  provides security risk rating of a company. It offers rating from A-D and F rating across 12 dimensions like Port Reconnaissance, Patch rhythm, Socail Engineering, Malware infections etc. Also Provides a count of findings in each sub-dimension with the impact, score and remediation.<br/> External Cyber Score monitors company brand , products/services, executive and connected with ongoing cybercrime campaihns. With our automated 24x7 security monitoring service, You can stay on top of the latest cyber threats.
                </p>     
              </div>
            </div>
          </Accordion.Body>
        </Accordion>
      </div>
      <div className="card shadow mb-1 my-2">
        <Accordion className="mx-1 my-2 custom-accordion-button">
          <Accordion.Button
            as={Nav.Link}
            variant="link"
            eventKey="0"
            onClick={()=> setCollapsed(!collapsed)}
          >
            <div className='header-cont' >
              <div>
                <span className="m-2 card-heading-2">ECS Dashboard</span>
              </div>
              <div>{collapsed ? <KeyboardArrowUpIcon /> : <ExpandMoreIcon /> }</div>
            </div>
          </Accordion.Button>
          
          <Accordion.Body eventKey="0">
            <div className="card-body p-4">
              <div id="platfromtabcontent">
                <p className="card-text">
                  Once User logs in with the provided credentials, he will be viewing the <a style={{color:"blue" , }} href="/crs/dashboard/over-all">Over-all dashboard.</a>
                </p>
                <p className="card-text mt-3">
                  On the left-hand side pane, User can access 12 individual dimension dashboards wherein each dimension dashboard depicts their respective sub-dimensions and associated security scoring.
                </p>  
                <h6 id="h64" className='card-text-1'><b>In the Overall Dashboard we have the following elements:</b></h6>
                <ol className="ugorderlist card-text" type="1">
                  <li className="mt-3">
                    <b className='card-text-1 sub-heading-userguide'>RISK POSTURE</b>
                    <ul className="mt-1 d-flex"> <div><TripOriginIcon className="icon-user-ci"/></div> Severity Ranking displayed in the Risk Posture, will always be for the latest scan (last requested report date).</ul>
                    <ul className="mt-1 d-flex" > <div><TripOriginIcon className="icon-user-ci"/></div> <div>Scoring is based on the alert severity and weightages aligned with the industry standards. Each dimension (and sub dimension) holds a weightage reflecting relative impact on overall security.</div></ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Risk Posture is a weighted average of severity and weightage of all the dimensions indicating the degree of impact a vulnerability has on business.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>The changes of Critical Analysis will reflect to the Risk Posture.</ul>
                    <ul className="mt-1 d-flex"> <div> <TripOriginIcon className="icon-user-ci"/>  </div>Legend provided here, is as per the industry standards.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>A – Informational <br/> Threat Score = 0</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>B - Low <br/> Threat Score = 1 - 3</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>C - Medium <br/> Threat Score = 4 - 6</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>D - High <br/> Threat Score = 7 - 8</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>E – Critical <br/> Threat Score = 9 -10</ul>
                  </li>
                  <li >
                    <b className='card-text-1 sub-heading-userguide'>CURRENT ANALYSIS</b> 
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>This is a vertical bar chart showing findings count with respect to overall dimensions or individual sub-dimensions.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Initially User can see the bar chart for the latest scan date.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Later User has the provision to change the scan date and see the information for specific day(s).</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Whenever a User clicks on any Bar chart, say for example, on a critical alert bar chart, it will re-direct to the available critical alerts page for the selected scan date.</ul>
                  </li>
                  <li>
                    <b className='card-text-1 sub-heading-userguide mt-2'>VULNERABILITY TREND ANALYSIS </b> 
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Vulnerability Trend Analysis is the trend graph for the number of findings of a particular severity across time, over the 12 dimensions.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>User has the provision to see the trend for 1 week and 1 month.</ul>
                  </li>
                  <li className="mt-3" ><b className='card-text-1 sub-heading-userguide'>TOP ISSUES FOUND </b> 
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>By default, whenever User logs in, he/she can view the Top Issue Found (Critical/High/Medium) of the latest Scan.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>View all option is provided for the user under critical/high/medium to get into the details of all the respective findings for that dimension/sub-dimension.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Clicking on individual sub-dimensions under critical/high/medium you can view the details like impact, findings and remediation</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>The changes of Critical Analysis will reflect to Top Issues Found.</ul>
                  </li>
                  <li className="mt-3">
                    <b className='card-text-1 sub-heading-userguide'>THREAT ACTOR ANALYSIS</b> 
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>A threat actor is either a person or a group of people that take part in an action that is intended to cause harm to computers, devices, systems, or networks. </ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>They perform malicious acts against a person or an organization of any type or size.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Threat actors engage in cyber related offenses to exploit open vulnerabilities and disrupt operations.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>An advanced persistent threat (APT) is a sophisticated, sustained cyberattack in which an intruder establishes an undetected presence in a network in order to steal sensitive data over a prolonged period of time.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>Threat Actor Analysis shows all the threat actors (APT groups) from different places across the world.</ul>
                    <ul className="mt-1 d-flex" > <div> <TripOriginIcon className="icon-user-ci"/>  </div>The changes of Critical Analysis will reflect to Threat Actor Analysis.</ul>
                  </li>
                </ol> 
              </div>
            </div>
          </Accordion.Body>
        </Accordion>
      </div>
    </div>
  )
}

export default UserGuidePage
